// extracted by mini-css-extract-plugin
module.exports = {"input":"common_input__1o0G9"};